import EzController from 'controllers/ez-base-controller';
import { smoothScroll } from 'lib/helpers';

export default class SmoothScrollController extends EzController {
  scrollTo = (event) => {
    event.preventDefault();

    const scrollToId = event.target.dataset.scrollTo;
    const scrollOffset = document.querySelector(`#${scrollToId}`).offsetTop;

    smoothScroll(scrollOffset);
  }
}
